import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import { Table, Tag, message } from 'antd';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import portalService from '../../services/portalService';

const formatDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('es-PE', { year: 'numeric', month: 'short', day: 'numeric' });
};

const formatMoney = (value) => {
  if (value == null) return '—';
  return new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' }).format(Number(value));
};

const MiContrato = () => {
  const [contratos, setContratos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cargar = async () => {
      setLoading(true);
      try {
        const data = await portalService.obtenerMisContratos();
        setContratos(Array.isArray(data) ? data : []);
      } catch {
        message.error('No se pudo cargar su contrato');
      } finally {
        setLoading(false);
      }
    };
    cargar();
  }, []);

  const columns = [
    {
      title: 'Inmueble',
      key: 'inmueble',
      render: (_, r) => r.inmueble?.nombre || '—',
    },
    {
      title: 'Espacio',
      key: 'espacio',
      render: (_, r) => r.espacio?.nombre || '—',
    },
    {
      title: 'Inicio',
      dataIndex: 'fecha_inicio',
      render: formatDate,
    },
    {
      title: 'Fin',
      dataIndex: 'fecha_fin',
      render: formatDate,
    },
    {
      title: 'Alquiler',
      dataIndex: 'monto_alquiler',
      render: formatMoney,
    },
    {
      title: 'Día de pago',
      dataIndex: 'fecha_pago',
      render: formatDate,
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      render: (estado) => (
        <Tag color={estado === 'activo' ? 'success' : 'default'}>{estado || '—'}</Tag>
      ),
    },
  ];

  return (
    <div>
      <Header />
      <Sidebar activeClassName="mi-contrato" />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <ul className="breadcrumb">
              <li className="breadcrumb-item"><Link to="#">Mi portal</Link></li>
              <li className="breadcrumb-item"><FaChevronRight /></li>
              <li className="breadcrumb-item active">Mi contrato</li>
            </ul>
          </div>
          <div className="card">
            <div className="card-body">
              <h4 className="mb-3">Mis contratos de alquiler</h4>
              <Table
                rowKey="id"
                columns={columns}
                dataSource={contratos}
                loading={loading}
                pagination={{ pageSize: 5 }}
                locale={{ emptyText: 'No tiene contratos registrados' }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiContrato;
